import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit, ElementRef, Input } from '@angular/core';
import { FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ReservationDetailsModel } from 'src/app/_models/Reservation/ReservationModel';
import { VenueModelRequest } from 'src/app/_models/Venue/VenueModel';
import { ApiService } from 'src/app/_services/api.service';
import { VenueService } from 'src/app/_services/venue.service';
import { Operations } from "../../../_models/Reservation/ReservationStatus";

@Component({
  selector: 'app-reservation-details-dialog',
  templateUrl: './reservation-details-dialog.component.html',
  styleUrls: ['./reservation-details-dialog.component.scss']
})
export class ReservationDetailsDialogComponent implements OnInit {

  activeStep: number = 1;

  reservationId: string = '';
  reservationDetails: ReservationDetailsModel = {};
  loading: boolean = false;

  dialogTitle = "";

  constructor(
    private openFile:ElementRef,
    private dialogRef: MatDialogRef<ReservationDetailsDialogComponent>,
    private apiService: ApiService,
    private venueService: VenueService,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {

    this.reservationId = data.reservationId;
    this.dialogTitle = data.dialogTitle;
   }

  ngOnInit(): void {
    this.fetchData();
  }

  // shareCapacity(value: number) {
  //   this.capacity = value
  // }

  save() { // Save what should expect
    // let venueModel: VenueModelRequest = {}
    // venueModel.Name = this.venueForm.controls['venueName'].value
    // venueModel.Description = this.venueForm.controls['nameExtension'].value
    // venueModel.MaximumCapacity = this.capacity
    // venueModel.WebsiteUrl = 'test.com'
    // venueModel.Email = this.venueForm.controls['email'].value
    // venueModel.Phone = this.venueForm.controls['phone'].value
    // venueModel.Latitude = this.latitute
    // venueModel.Longitude = this.longitude
    // venueModel.Tags = ['Test', 'Test One', 'Test Three']
    // venueModel.VenueImageFile = this.venueForm.controls['venueImagePath'].value

    // this.apiService.addVenue(venueModel).subscribe(() => {
    //   this.venueForm.reset();
    //   this.dialogRef.close(this.venueForm.value);
    // })

    // this.venueForm.reset();
    // console.log(this.venueForm.value);
    // this.dialogRef.close(this.capacity);
    this.dialogRef.close();
  }

  close() {
    this.dialogRef.close();
  }

  approve(){
    this.loading=true;
    this.apiService.confirmReservation(this.reservationId).subscribe(()=>{
      if(this.reservationDetails.eventId){
        this.reloadReservations(this.reservationDetails?.eventId);
        this.loading=false;
        this.dialogRef.close();
      }
    });
  }

  refuse(){
    this.loading=true;
    this.apiService.refuseReservation(this.reservationId).subscribe(()=>{
      if(this.reservationDetails.eventId){
        this.reloadReservations(this.reservationDetails?.eventId);
        this.loading=false;
        this.dialogRef.close();
      }
    });
  }

  reloadReservations(eventId: string): void {
    this.apiService.getReservations(eventId, Operations.WaitingApproval).subscribe(_ =>
      this.apiService.getReservations(eventId, Operations.WaitingApprovalChanged, true).subscribe()
    );
  }

  private fetchData() {//init dialog with data
    this.apiService.getReservationDetails(this.reservationId).subscribe((response)=>{
      this.reservationDetails = response;
      if(this.reservationDetails.createDate){
        this.formateDate(this.reservationDetails);
      }
    });
  }

  formateDate(reservation: ReservationDetailsModel){
    const datepipe: DatePipe = new DatePipe('en-US');
    //z for local timezone
    let date = new Date((reservation.createDate as string)+"Z");
    let formattedDate = datepipe.transform(date, 'EE, d MMM | hh:mm a')
      if(formattedDate !== null) {
        reservation.createDate = formattedDate;
      }
  }
}
